import { articles } from '@/mocks/categories';

export default function ArticleCards() {
  return (
    <section id="guides" className="py-16 md:py-20 bg-background-100">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="text-xs md:text-sm font-medium text-primary-600 tracking-widest uppercase">Resources</span>
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 mt-3 leading-tight">
            Buying Guides
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            In-depth articles to help you master CSSBuy spreadsheets, shipping strategies, and quality checking.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {articles.map((article) => (
            <a
              key={article.slug}
              href={`/article/${article.slug}`}
              className="group flex flex-col p-6 md:p-7 bg-background-50 rounded-lg border border-background-200/70 hover:border-primary-200/50 transition-all cursor-pointer"
            >
              <div className="w-11 h-11 flex items-center justify-center rounded-lg bg-primary-100 mb-5 group-hover:bg-primary-200 transition-colors">
                <i className={`${article.icon} text-xl text-primary-600`}></i>
              </div>
              <h3 className="text-base md:text-lg font-semibold text-foreground-900 mb-2 group-hover:text-primary-700 transition-colors leading-snug">
                {article.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed flex-1">
                {article.excerpt}
              </p>
              <span className="inline-flex items-center gap-1 mt-4 text-sm font-medium text-primary-600 whitespace-nowrap">
                Read Guide
                <i className="ri-arrow-right-line text-sm"></i>
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}